<template>
  <div class="content">
    <div id="nav" class="row">
      <Updates/>
      <Profile/>
      <Header/>
      <Register/>
      <Contact/>
    </div>
  </div>
</template>

<script>
import Updates from './components/Updates.vue'
import Profile from './components/Profile.vue'
import Header from './components/Header.vue'
import Register from './components/Register.vue'
import Contact from './components/Contact.vue'

export default {
  name: 'App',
  components: {
    Updates,
    Profile,
    Header,
    Register,
    Contact
  }
}
import $ from 'jquery';

$( document ).ready(function() {
  $(".grid-x").click(function() {
    updateX(this);
    updateY(this);
  });
  $(".logo-outline").click(function() {
    $(".grid-x").removeClass("grid-x-ignore").removeClass("grid-x-focus").removeClass("grid-y-ignore").removeClass("grid-y-focus");
    $(this).removeClass("left").removeClass("right");
  });
});

var updateX = function (elem) {
  if($(elem).hasClass("text-left")) {
    $(".grid-x.text-right").addClass("grid-x-ignore").removeClass("grid-x-focus");
    $(".grid-x.text-left").addClass("grid-x-focus").removeClass("grid-x-ignore");
    $(".logo-outline").addClass("right").removeClass("left");
  } else if($(elem).hasClass("text-right")) {
    $(".grid-x.text-left").addClass("grid-x-ignore").removeClass("grid-x-focus");
    $(".grid-x.text-right").addClass("grid-x-focus").removeClass("grid-x-ignore");
    $(".logo-outline").addClass("left").removeClass("right");
  }
}
var updateY = function (elem) {
  if($(elem).hasClass("grid-y1")) {
    $(".grid-y1").addClass("grid-y-focus").removeClass("grid-y-ignore");
    $(".grid-y2").addClass("grid-y-ignore").removeClass("grid-y-focus");
  } else {
    if($(elem).hasClass("grid-y2")) {
      $(".grid-y1").addClass("grid-y-ignore").removeClass("grid-y-focus");
      $(".grid-y2").addClass("grid-y-focus").removeClass("grid-y-ignore");
    }  
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Alatsi|Changa+One|DM+Serif+Display|Exo+2|Katibeh|Patua+One|Space+Mono|ZCOOL+QingKe+HuangYou&display=swap');
html, body, .content, #nav { 
  height:100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#nav {
  font-size: 18px!important;
  font-weight: bold!important;
}
div.content {
  margin: 0 auto;
  background-color: #232323;
}

a {
  color: #00B7FF;
}

body {
  background-color: rgb(48, 65, 71)!important;
  color: rgb(165, 165, 165);
  background-color: rgb(48, 65, 71);
  text-align: center;
  font-family: 'Patua One', Georgia, 'Times New Roman', Times, serif!important;
  text-transform: uppercase;
}

.grid-x span {
  transition: all 1s ease;
}
.grid-x:hover span {
  transition: all 1s ease;
  color: white;
}
span.updates {
  bottom: 20px;
  position: absolute;
  right: 20px;
}
span.profile {
  bottom: 20px;
  position: absolute;
  left: 20px; 
}

span.register {
  top: 20px;
  position: absolute;
  right: 20px;
}

span.contact {
  top: 20px;
  position: absolute;
  left: 20px;
}

.horizontal-bar {
  background-color:black;
  height: 1px;
  width:50%;
}
.vertical-bar {
  background-color:black;
  width: 1px;
  height:50%; 
}
*, ::after, ::before {
  box-sizing: content-box!important;
}

.grid-y1, .grid-y2 {
  height: 50%;
 }
 
.grid-y-focus {
  height: calc(100% - 65px);
}
.grid-y-ignore {
  height: 65px;
}

.grid-x {
  color: darkgrey;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
  -ms-flex: 1 0 41.666667%!important;
  flex: 1 0 41.666667%!important;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  transition: all 0.5s cubic-bezier(0.71, 0.25, 0.02, 1);
  max-width: 80%;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}

.grid-x-focus {
  flex: 1 0 calc(100% - 200px)!important;
  -ms-flex: 1 0 calc(100% - 200px)!important;
  max-width: 90%!important;
}
.grid-x-ignore {
  -ms-flex: 1 0 60px!important;
  flex: 1 0 60px!important;
}

h2.hadyna {
  color: #000033;
}

@media only screen and (max-width: 750px) {
  .logo-outline.left {
    left: 25%;
  }
  .logo-outline.right {
    left: 75%;
  }
}
</style>
